import "core-js/modules/es.array.push.js";
import httpRequest from '@/request/index';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { showToast, showFailToast, showLoadingToast, closeToast, showConfirmDialog } from 'vant';
import { useRouter } from "vue-router";
import 'vant/es/dialog/style';
export default {
  setup() {
    const store = useStore();
    const pay_name = ref("请选择");
    const formData = ref({
      recharge_no: "",
      pay_type: 0,
      pay_time: "",
      recharge_about: ""
    });
    const router = useRouter();
    const addid = ref(0);
    const payList = ref([]);
    const showDel = ref(false);
    const showPicker = ref(false);
    const showTime = ref(false);
    const minDate = new Date(2023, 0, 1);
    const maxDate = new Date();
    const now = new Date();
    const currentDate = ref([now.getFullYear(), now.getMonth() + 1, now.getDate()]);
    const currentTime = ref([now.getHours(), now.getMinutes(), now.getSeconds()]);
    console.log(now.getFullYear(), now.getMonth() + 1, now.getDate());
    const selType = ({
      selectedOptions
    }) => {
      formData.value.pay_type = selectedOptions[0].value;
      pay_name.value = selectedOptions[0].text;
      showPicker.value = false;
    };
    const selTime = () => {
      console.log(currentDate.value, currentTime.value);
      formData.value.pay_time = currentDate.value.join('-') + " " + currentTime.value.join(':');
      showTime.value = false;
    };
    const onDelete = () => {
      showConfirmDialog({
        message: '确认删除该记录？',
        theme: 'round-button'
      }).then(() => {
        httpRequest({
          method: "get",
          url: "?file=recharge&act=del&id=" + addid.value
        }).then(res => {
          if (res.state == 1) {
            showToast({
              message: res.msg,
              onClose: function () {
                router.push("/recharge");
              }
            });
          } else {
            showFailToast(res.msg);
          }
        });
      }).catch(() => {});
    };
    const saveInfo = () => {
      if (formData.value.recharge_no == "") {
        showFailToast("充值金额不能为空");
        return false;
      }
      if (formData.value.pay_type == 0) {
        showFailToast("支付方式不能为空");
        return false;
      }
      if (formData.value.pay_time == "") {
        showFailToast("付款时间不能为空");
        return false;
      }
      httpRequest({
        method: "post",
        url: "?file=recharge&act=save&id=" + addid.value,
        data: formData.value
      }).then(res => {
        if (res.state == 1) {
          showToast({
            message: res.msg,
            onClose: function () {
              router.push("/recharge");
            }
          });
        } else {
          showFailToast(res.msg);
        }
      });
    };
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
      httpRequest({
        method: "get",
        url: "?file=recharge&act=paytype"
      }).then(res => {
        if (res.state == 1) {
          formData.value.pay_type = res.list[0].value;
          pay_name.value = res.list[0].text;
          payList.value = res.list;
        } else {
          showFailToast(res.msg);
        }
      });
      formData.value.pay_time = maxDate.toLocaleDateString() + " " + maxDate.toLocaleTimeString();
      if (router.currentRoute.value.query.id > 0) {
        showLoadingToast({
          message: '加载中',
          forbidClick: true
        });
        addid.value = router.currentRoute.value.query.id;
        showDel.value = true;
        httpRequest({
          method: "get",
          url: "?file=recharge&act=edit&id=" + addid.value
        }).then(res => {
          closeToast();
          if (res.state == 1) {
            formData.value = res.info;
            pay_name.value = res.pay_name;
            const date = new Date(formData.value.pay_time);
            currentDate.value = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
            currentTime.value = [date.getHours(), date.getMinutes(), date.getSeconds()];
          } else {
            showFailToast(res.msg);
          }
        });
      }
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      formData,
      payList,
      onDelete,
      saveInfo,
      showDel,
      goBack,
      showPicker,
      selType,
      pay_name,
      showTime,
      selTime,
      maxDate,
      minDate,
      currentDate,
      currentTime
    };
  }
};